<template>
   <div class='process-header'>
      <div class="title">Energy Planning Process</div>
      <plan-description/>
      <steps v-if="!noSteps" :step="step" @select-index="handleStepSelection"/>
   </div>
</template>

<script>
import PlanDescription from '../PlanDescription';
import Steps from '../Steps';

export default {
   name: 'planning-process-header',
   components: {
      Steps,
      PlanDescription,
   },
   props: {
      step: {
         type: Number,
      },
      noSteps: {
         type: Boolean,
         default: false,
      }
   },
   methods: {
      handleStepSelection(stepIndex)
      {
         console.log(stepIndex);
      }
   }
}
</script>

<style lang="scss" scoped>
.process-header {
   font-family: $primary-font;
   color: $font-color;
   > .title {
      width: 100%;
      background-color: darken(white,0.5%);
      border-bottom: 1px solid rgba(black,0.2);
      padding: 0.6em 1em;
   }
}
</style>